import { Component, OnInit, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Auth } from '@aws-amplify/auth';
import { AuthService } from '../auth/auth.service';
import { Constant } from '../constant';
import { Title } from '@angular/platform-browser';
import { CommonUtil } from '../util/common-util';
import { ToastUtil } from '../util/toast-util';
import { MatDialog } from '@angular/material/dialog';
import { AccountEditDialogComponent } from '../dialog/account-edit-dialog/account-edit-dialog.component';
import { AccountPasswordResetDialogComponent } from '../dialog/account-password-reset-dialog/account-password-reset-dialog.component';
import { AccountDeleteDialogComponent } from '../dialog/account-delete-dialog/account-delete-dialog.component';
import { GeneralYesNoDialogComponent } from '../dialog/general-yes-no-dialog/general-yes-no-dialog.component';
import { Router,RouterModule  } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DatePipe } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    selector: 'organization-account',
    templateUrl: './organization-account.component.html',
    styleUrl: './organization-account.component.css',
    standalone: true,
    providers: [DatePipe],
    imports: [
      MatMenuModule,
      MatButtonModule,
      MatIconModule,
      CommonModule,
      RouterModule,
      MatProgressSpinnerModule
    ]
})
export class OrgAccountComponent {
  public tellNo = Constant.calinTellNo + Constant.calinWorkTime;
  public supportMail = Constant.calinSupportMail;
  public accounts;
  public tagMaster;
  public apiPath = '/account';
  public readonly Constant = Constant;
  public showSpinner = true;
  public companyCode;
  public isPermissionOpen = false;
  private readonly PASSWORD_EXPIRE_DAYS = 7;

  constructor(
    private title: Title,
    private router: Router,
    private commonUtil: CommonUtil,
    private toastUtil: ToastUtil,
    private dialog: MatDialog,
    private auth: AuthService,
    private datePipe: DatePipe
  ) {
    this.title.setTitle(Constant.pageTitleOrganizationaccount + Constant.pageTitleCommon);
  }

  @HostListener('window:focus')
  onFocus(): void {
    this.commonUtil.checkRefreshToken(this.auth);
  }

  ngOnInit() {
    window.scroll(0, 0);
    if (!this.commonUtil.checkOnline()) {
      this.showSpinner = false;
      return;
    }
    // 記事データを取得する
    this.getPrContentsData();
    this.companyCode = localStorage.getItem(this.Constant.lsCompanyCode) ?? '';
  }

  // 編集画面表示
  onEdit(index?) {

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    if (!this.commonUtil.isOnline()) {
      this.showErrorToast(Constant.msgNetworkError);
      return;
    }

    let type;
    let account_id = 0;
    if (index != null) {
      account_id = this.accounts[index].id;
      type = Constant.joTypeEdit;
    } else {
      type = Constant.joTypeAdd;
    }

    const dialogRef = this.dialog.open(AccountEditDialogComponent, {
      width: Constant.accountEditDialogWidth,
      autoFocus: false,
      disableClose: true,
      data: {
        type: type,
        id: account_id
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== Constant.empty) {
        this.getPrContentsData();
      }
    });
  }

  togglePermission() {
    this.isPermissionOpen = !this.isPermissionOpen;
  }

  onPasswordReset(index?) {

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    if (!this.commonUtil.isOnline()) {
      this.showErrorToast(Constant.msgNetworkError);
      return;
    }

    let type;
    let account_id = 0;
    if (index != null) {
      account_id = this.accounts[index].id;
      type = Constant.joTypeEdit;
    } else {
      type = Constant.joTypeAdd;
    }

    const dialogRef = this.dialog.open(AccountPasswordResetDialogComponent, {
      width: Constant.accountEditDialogWidth,
      autoFocus: false,
      disableClose: true,
      data: {
        type: type,
        id: account_id
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== Constant.empty) {
        this.getPrContentsData();
      }
    });
  }

  // 削除
  onDel(index) {

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    if (!this.commonUtil.isOnline()) {
      this.showErrorToast(Constant.msgNetworkError);
      return;
    }
    let account_id = 0;
    account_id = this.accounts[index].id;

    const dialogRef = this.dialog.open(AccountDeleteDialogComponent, {
      width: Constant.accountEditDialogWidth,
      autoFocus: false,
      disableClose: true,
      data: {
        id: account_id
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== Constant.empty) {
        this.getPrContentsData();
      }
    });
  }

  // 詳細URLをコピー
  onUrlCopy(index: string) {
    let element: HTMLElement;
    element = document.getElementById('url-code-' + index);

    if (element) {
      const temp = document.createElement('div');
      temp.appendChild(document.createElement('span')).textContent = element['value'];
      document.body.appendChild(temp);
      document.getSelection().selectAllChildren(temp);
      const succeeded = document.execCommand('copy');

      if (succeeded) {
        // コピー成功
        this.toastUtil.clearAllShowingToast();
        this.toastUtil.showInformationToast('', Constant.msgCopySuccess, Constant.toastShowMiliSec);
      } else {
        // コピー失敗
        this.toastUtil.clearAllShowingToast();
        this.toastUtil.showErrorToast('', Constant.msgCopyError, Constant.toastShowMiliSec);
      }
      document.body.removeChild(temp);
    }
  }

  formatDate(dateStr: string): string {
    //return this.datePipe.transform(
    //  dateStr.replace(' ', 'T'), // MySQL形式対策
    //  'yyyy/MM/dd HH:mm',
    //  'Asia/Tokyo'
    //)!;
    const date = new Date(dateStr.replace(' ', 'T'));

    return date.toLocaleString('ja-JP', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  }

  openSignupUrl(): void {
    const url = `${Constant.unionestSignupUrl}${this.companyCode}`;
    window.open(url, '_blank');
  }

// 失効判定
isPasswordExpired(updatedAt: string): boolean {
  if (!updatedAt) return false;

  const updated = new Date(updatedAt.replace(' ', 'T'));
  const expire = new Date(updated);
  expire.setDate(expire.getDate() + this.PASSWORD_EXPIRE_DAYS);

  return new Date().getTime() >= expire.getTime();
}

// 表示文言
getPasswordExpireText(updatedAt: string): string {
  if (!updatedAt) return '';

  const updated = new Date(updatedAt.replace(' ', 'T'));
  const expire = new Date(updated);
  expire.setDate(expire.getDate() + this.PASSWORD_EXPIRE_DAYS);

  const now = new Date();
  const diffMs = expire.getTime() - now.getTime();

  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24)) + 1;

  if (diffDays <= 0) {
    return '失効';
  }

  return `${diffDays}日後に失効`;
}


  /*
   * プライベート関数
   */

  // 記事情報を取得する
  private getPrContentsData() {
    if (!this.commonUtil.isOnline()) {
      this.showSpinner = false;
      return;
    }

    // ぐるぐる表示
    this.showSpinner = true;
    this.accounts = null;
    Auth.currentSession().then(session => {
      const options = this.auth.createApiHeader(session);
      this.commonUtil
        .apiGet(this.apiPath, options)
        .then(res => {
          this.accounts = res.data;
          // コンテンツのタグマスターデータを取得する
          this.commonUtil.debug().log(this.accounts);
          this.showSpinner = false;
        })
        .catch(err => {
          this.commonUtil.debug().log(err);
          if (err.message === Constant.msgLoginFailed) {
            this.commonUtil.showReloadDialog(this.auth);
          } else {
            this.showSpinner = false;
            this.toastUtil.showErrorToast('', Constant.msgNetworkError, Constant.toastShowMiliSec);
          }
        });
    });
  }

  getMasterTypeName(master_type: number): string {
    switch(master_type) {
      case 1: return '本部';
      case 2: return '支部';
      case 3: return 'エリア';
      default: return '';
    }
  }

  // 記事の削除API呼び出し
  private delPrContents(index) {
    if (!this.commonUtil.isOnline()) {
      this.showErrorToast(Constant.msgNetworkError);
      return;
    }

    this.showSpinner = true;
    Auth.currentSession().then(session => {
      const options = this.auth.createApiHeader(session);
      options['body'] = {
        contents_id: index
      };

      this.commonUtil
        .apiDel(this.apiPath, options)
        .then(res => {
          this.showToast(Constant.msgNoticeDel);
          this.getPrContentsData();
        })
        .catch(err => {
          if (err.message === Constant.msgLoginFailed) {
            this.commonUtil.showReloadDialog(this.auth);
          } else {
            this.showErrorToast(Constant.msgNoticeDelFailed);
            this.getPrContentsData();
          }
        });
    });
  }

  // トースト表示
  private showToast(msg) {
    this.toastUtil.clearAllShowingToast();
    this.toastUtil.showInformationToast(Constant.empty, msg, Constant.toastShowMiliSec);
  }

  // エラートースト表示
  private showErrorToast(msg) {
    this.toastUtil.clearAllShowingToast();
    this.toastUtil.showErrorToast(Constant.empty, msg, Constant.toastShowMiliSec);
  }
}
